// Import firebase
import { firebaseAuth, propertiesModel } from '@/firebase/firebase-config'

// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

export const RemoveLateStatus = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        SpinnerMethods

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        error: false

    }),

    /*
	**  Methods
    */
    
    methods: {

        removeLateStatusHandler: function() {

            /*
            **  Remove the line item
            **  @method: @here
            */

            this.removeLineItem()
            .then(() => {

                /*
                **  Update the Totals
                **  @method: @here
                */

                if (!this.error) this.setTotalsRemoveLate();

            })
            .then(() => {

                /*
                **  Update ACH Fees
                **  @method: @here
                */

                if (!this.error) this.setACHFeesRemoveLate();

            })
            .then(() => {

                /*
                **  Update Card Fees
                **  @method: @here
                */

                if (!this.error) this.setCardFeesRemoveLate();

            })
            .then(() => {

                /*
                **  Update the invoice
                **  @method: @here
                */
    
                if (!this.error) this.updateInvoiceRemoveLate();

            })
            .then(() => {

                /* 
                ** Remove late fees from rent metrics
                ** @method: @here
                */

                if (!this.error) this.updateRentMetricsLateFeesRemoveLate();

            });            

        },

        handleError: function() {

            /* 
            ** Close the modal
            ** @location: Components/Property/Lease/Invoices/EditInvoiceModal
            */

            this.closeTheModal();

            /* 
            ** Hide the spinner
            ** @location: Mixins/Helpers/SpinnerMethods
            */

            this.hideSpinner();

            /* 
            ** Display error message
            ** @service: @Window/SweetAlert
            */

            this.$swal('Uh Oh!', 'We ran into a problem trying to update the invoice.', 'error');

        },

        removeLineItem: async function() {


            /* 
            ** Find the late fee and remove
            ** @method: @here
            */

            try {

                /* 
                ** Set the var
                */

                let new_line_items = [];

                /* 
                ** Loop through the array
                */

                this.invoice.attributes.line_items.forEach(line_item => {

                    if (line_item.type !== 'late_fee') new_line_items.push(line_item);

                });

                /* 
                ** Add to the invoice object
                */

                this.invoice.attributes.line_items = new_line_items;


            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
                
                this.reportAuthBugsnagError({
                    title: 'Removing the late fee line item from a late invoice.',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'Yadnr7C3fDhQE3iPQU7X',
                    error: e
                });

            }

        },

        setACHFeesRemoveLate: function() {

            try {

                /*
                **  Set the total amount
                */

                let total = this.invoice.attributes.charge.total;
    
                /*
                **  Calculate the Stripe variables
                */

                let stripeACHPercent =  Number(process.env.VUE_APP_STRIPE_ACH_FEE_PERCENT) + Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_PERCENT),
                    stripeACHCents = Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_CENTS);
    
                /*
                **  Calculate platform fees
                */

                let platformFee = total * Number(process.env.VUE_APP_PLATFORM_FEE_PERCENT);
                platformFee = Math.ceil(platformFee);
    
                /*
                **  Calculate stripe fees
                */

                let stripeFee = (total * stripeACHPercent) + stripeACHCents;
                stripeFee = Math.ceil(stripeFee);

                /*
                **  Calculate the total fees in pennies
                */
                
                let totalFees = platformFee + stripeFee;

                /*
                **  Calculate connect account amount
                */
                
                let connectAccountAmount = total - totalFees;
    
                /*
                **  Set the fees
                */
                
                this.invoice.attributes.charge.ach_fees.stripe.amount = Number(stripeFee);
                this.invoice.attributes.charge.ach_fees.platform.amount = Number(platformFee);
                this.invoice.attributes.charge.ach_fees.total_fees = Number(totalFees);
                this.invoice.attributes.charge.ach_fees.connect_account_amount = connectAccountAmount;

            } catch (e) {
                
                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
                
                this.reportAuthBugsnagError({
                    title: 'Setting ACH Fees when removing invoice late status.',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'G0wTqK8K6dEo0L131dTX',
                    error: e
                });

            }

		},

        setCardFeesRemoveLate: function() {

            try {

                /*
                **  Set the total amount
                */

                let total = this.invoice.attributes.charge.total;
    
                /*
                **  Calculate the Stripe variables
                */

                let stripeCardPercent = Number(process.env.VUE_APP_STRIPE_CARD_FEE_PERCENT) + Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_PERCENT),
                    stripeCardCents = Number(process.env.VUE_APP_STRIPE_CARD_FEE_CENTS) + Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_CENTS);
    
                /*
                **  Calculate platform fees
                */
                
                let platformFee = total * Number(process.env.VUE_APP_PLATFORM_FEE_PERCENT);
                platformFee = Math.ceil(platformFee);

                /*
                **  Calculate stripe fees
                */

                let stripeFee = (total * stripeCardPercent) + stripeCardCents;
                stripeFee = Math.ceil(stripeFee);
    
                /*
                **  Calculate the total fees in pennies
                */

                let totalFees = platformFee + stripeFee;

                /*
                **  Calculate connect account amount
                */

                let connectAccountAmount = total - totalFees;

                /*
                **  Set the props
                */

                this.invoice.attributes.charge.card_fees.stripe.amount = Number(stripeFee);
                this.invoice.attributes.charge.card_fees.platform.amount = Number(platformFee);
                this.invoice.attributes.charge.card_fees.total_fees = Number(totalFees);
                this.invoice.attributes.charge.card_fees.connect_account_amount = connectAccountAmount;

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
                
                this.reportAuthBugsnagError({
                    title: 'Setting Card Fees when removing invoice late status.',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'iXQGZi5m1vR5emeWBEBI',
                    error: e
                });

            }

		},

        setTotalsRemoveLate: function() {

            try {

                /*
                **  Update Total
                */

                this.invoice.attributes.charge.total = this.invoice.attributes.charge.amount + this.invoice.attributes.charge.transaction_fee;

                /*
                **  Update Subtotal
                */

                this.invoice.attributes.charge.subtotal = this.invoice.attributes.charge.total;

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
                
                this.reportAuthBugsnagError({
                    title: 'Setting the invoice totals when removing invoice late status.',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'Ro6HZe5MULEnIa8FAqAp',
                    error: e
                });

            }

        },

        updateRentMetricsLateFeesRemoveLate: function() {

            try {

                /*
                **  Calculate metrics
                */

                let totalLate = this.rent.metrics.total_late - 1;

                /*
                **  Handle negative calculations
                */

                if (totalLate < 0) totalLate = 0;

                /*
                **  Update the doc
                **  @service: Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease_id).collection('rents').doc(this.rent_id).update({
                    
                    'metrics.total_late': totalLate,
                    'attributes.status': 'current',
                    'meta.updated_at': moment().unix()

                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Update Total Late Metrics in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'zwwgLUym3NkW9hXOcGr8',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating Total Late Metrics.',
                    errorType: 'Firestore Database',
                    section: 'Events/Invoices',
                    uid: 'H3ZGpL0Sf7GcUD4UYdpI',
                    error: e
                });

            }

        },

        updateInvoiceRemoveLate: function() {

            try {

                /*
                **  Update the doc
                **  @service: Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.invoice.relationships.lease).collection('rents').doc(this.invoice.relationships.rent).collection('invoices').doc(this.invoice.id).update({
                    'attributes.line_items': this.invoice.attributes.line_items,
                    'attributes.charge': this.invoice.attributes.charge,
                    'meta.updated_at': moment().unix()
                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Update Invoice to Include Updated Line Items and Charge Details in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'MGYO7NwYXZWm7XaqWcMG',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating an Invoice to Include Updated Line Items and Charge Details.',
                    errorType: 'Firestore Database',
                    section: 'Events/Invoices',
                    uid: 'CeDVPoh3Z26fChzTFhD2',
                    error: e
                });

            }

        }

    }

}